<template>
  <card-canvas>   
    <add-global-task 
      @task-created="(projectID, id, createAnother) => handleTaskCreated(projectID, id, createAnother)"
      @canceled="$router.go(-1)"
    />
  </card-canvas>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'GlobalTaskCreate',

  components: {
    CardCanvas,
  },

  data() {
    return {
      RouteAssistant,
    }
  },

  head: {
    title: 'New Task',
  },

  computed: {
    projectID(): number {
      return Number(this.$route.params.id)
    },
  },

  mounted() {},

  methods: {
    handleTaskCreated(projectID: number, id: number, createAnother: boolean) {
      if (!createAnother) {
        RouteAssistant.goToTask(
          this.$router,
          this.$route.params.accountId,
          projectID,
          id,
          this.$permissions,
        )
      }
    },
  },
})
</script>
